import React, { useEffect, createContext, useState } from "react";
import en from "../LanguageFiles/en.json";
import es from "../LanguageFiles/es.json";
import i18n from "../../i18n";

const LocalizationContext = createContext({});

interface Props {
    children: JSX.Element;
}

export const LocalizationProvider = ({ children }: Props) => {
    const [locale, setLocale] = useState('en');
    const [texts, setTexts] = useState<any>(en);

    useEffect(() => {
        document.title = locale === 'es' ? "Inscripción" : "Registration";
        const localizationFile = locale === 'es' ? es : en;
        setTexts(localizationFile);
        i18n.changeLanguage(locale);
    }, [locale]);


    const getValue = (component: string, key: string) => {
        return texts[component][key]
    } 

    const getComponent = (component: string) => {
        return texts[component]
    }

    const value = {
        locale,
        setLocale,
        texts,
        getValue,
        getComponent
    }

    return (
        <LocalizationContext.Provider value={value}>
            {children}
        </LocalizationContext.Provider>
    );
}

export default LocalizationContext;